export const BOOK = {
  // selection
  selCategory: "book-sel-category",
  selSize: "book-sel-size",
  selTier: "book-sel-tier",
  // schedule
  dropoffDate: "book-dropoff-date",
  timeWindow: "book-time-window",
  pickupDate: "book-pickup-date",
  instructions: "book-instructions",
  // contact
  cName: "book-c-name",
  cCompany: "book-c-company",
  cEmail: "book-c-email",
  cPhone: "book-c-phone",
  // billing
  bLine1: "book-b-line1",
  bLine2: "book-b-line2",
  bCity: "book-b-city",
  bProvince: "book-b-province",
  bPostal: "book-b-postal",
  // shipping
  shipSame: "book-ship-same",
  sLine1: "book-s-line1",
  sLine2: "book-s-line2",
  sCity: "book-s-city",
  sProvince: "book-s-province",
  sPostal: "book-s-postal",
  // pay
  payButton: "book-pay-button",
  payStatus: "book-pay-status",
};
